const axios = require('axios');
const assert = require('assert');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class BookingHistoryServiceConnector {

  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async getMyHistory({ filter, page = 0, maxPerPage = 10, sort, bookingPaymentRequiresAction = false }) {
    assert(filter, 'filter is required');
    try {
      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/history/me`, {
        params: { filter, page, maxPerPage, sort, bookingPaymentRequiresAction },
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getAdministrativeHistory({ filter, page = 0, maxPerPage = 10, corporationId, startDate, endDate, sort }) {
    assert(filter, 'filter is required');
    assert(corporationId, 'corporationId is required');
    try {
      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/history`, {
        params: { filter, page, maxPerPage, corporationId, startDate, endDate, sort },
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getHistoryDetails({ id }) {
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/history/details/${id}`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }

}

module.exports = {
  BookingHistoryServiceConnector,
};
